module.exports = __webpack_public_path__ + "img/presscoins-own-coin.97c62dac.png";